import { useMemo } from 'react'
import {
  AttendanceBody,
  Donut,
  DonutHole,
  DonutCount,
  DonutSub,
  Legend,
  LegendRow,
  LegendDot,
  LegendLabel,
  LegendValue,
  LegendPct,
} from 'pages/HrDashboard/hrLayout.styled'

interface IDistRow {
  label: string
  value: number
  color: string
}

interface IDistributionDonutProps {
  rows: IDistRow[]
  centerLabel: string
}

export const DistributionDonut = ({ rows, centerLabel }: IDistributionDonutProps) => {
  const { gradient, total, legend } = useMemo(() => {
    const sum = rows.reduce((s, r) => s + r.value, 0)
    let acc = 0
    const stops = rows
      .filter((r) => r.value > 0)
      .map((r) => {
        const start = sum ? (acc / sum) * 100 : 0
        acc += r.value
        const end = sum ? (acc / sum) * 100 : 0
        return `${r.color} ${start}% ${end}%`
      })
    const grad = stops.length ? `conic-gradient(${stops.join(', ')})` : 'conic-gradient(#3C3C3C 0 100%)'
    const leg = rows.map((r) => ({ ...r, pct: sum ? Math.round((r.value / sum) * 100) : 0 }))
    return { gradient: grad, total: sum, legend: leg }
  }, [rows])

  return (
    <AttendanceBody>
      <Donut $gradient={gradient}>
        <DonutHole>
          <DonutCount>{total}</DonutCount>
          <DonutSub>{centerLabel}</DonutSub>
        </DonutHole>
      </Donut>
      <Legend>
        {legend.map((r) => (
          <LegendRow key={r.label}>
            <LegendDot $color={r.color} />
            <LegendLabel>{r.label}</LegendLabel>
            <LegendValue>{r.value}</LegendValue>
            <LegendPct>{r.pct}%</LegendPct>
          </LegendRow>
        ))}
      </Legend>
    </AttendanceBody>
  )
}
